import { RouteStatusEnum } from '../../enums';
import { ICoordinate } from '../coordinate.interface';

export interface IRouteSchema {
    id: string;
    organizationId?: string;
    externalId?: string | null;
    name: string;
    status: RouteStatusEnum;
    statusMessage?: string;
    fileUrl?: string;
    /** Flexpolyline-encoded track, produced by the KML enrichment. */
    polyline?: string;
    origin?: ICoordinate;
    destination?: ICoordinate;
    originAddress?: string;
    destinationAddress?: string;
    createdAt?: string;
    updatedAt?: string;
    distanceKm?: number;
    isDeleted?: boolean;
    deletedAt?: string;
}
